export const stripWhiteSpace = (val = '') => val.replace(/\W/g, '')

export const capitalizeFirstLetter = (word?: string) => {
  let result: string | null = ''
  if (word != null) {
    word = word.toLowerCase()
    const chars = word.split(' ')
    chars.map((w, i) => {
      if (chars.length - 1 === i) {
        result += w.charAt(0).toUpperCase() + w.slice(1)
      } else {
        result += w.charAt(0).toUpperCase() + w.slice(1) + ' '
      }
    })
  } else {
    result = null
  }
  return result
}
